"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitemapContribution = void 0;
exports.getSitemapEligibleRoutes = getSitemapEligibleRoutes;
exports.generateSitemapXml = generateSitemapXml;
const react_1 = __importStar(require("react"));
const inversify_1 = require("inversify");
const routes_1 = require("@authlance/core/lib/common/routes/routes");
const lucide_react_1 = require("lucide-react");
const user_routes_provider_1 = __importDefault(require("@authlance/core/lib/browser/hooks/user-routes-provider"));
/**
 * Generates a sitemap.xml for all public, prerender-enabled routes.
 *
 * This contribution uses RoutesProvider.getFlatRoutes() to collect all registered routes,
 * filters for those with `authRequired: false` and `prerender.enabled: true`,
 * then renders an XML sitemap compatible with the Sitemaps protocol.
 *
 * Routes with path parameters (e.g., /user/:id) are excluded by default since
 * they cannot be statically enumerated. Future enhancement could support a
 * `sitemapPaths` config on RouteContribution to enumerate dynamic values.
 */
const SITEMAP_CANONICAL_BASE_URL = resolveSitemapBaseUrl();
function resolveSitemapBaseUrl() {
    var _a;
    const env = typeof process !== 'undefined' ? (_a = process.env) !== null && _a !== void 0 ? _a : {} : {};
    const raw = (typeof env.AUTHLANCE_PUBLIC_URL === 'string' && env.AUTHLANCE_PUBLIC_URL.trim()) ||
        (typeof env.ROOT_APP_URL === 'string' && env.ROOT_APP_URL.trim()) ||
        (typeof env.APP_URL === 'string' && env.APP_URL.trim()) ||
        'https://authlance.com';
    return raw.replace(/\/+$/, '') || 'https://authlance.com';
}
function normalizeRoutePath(path) {
    if (!path) {
        return '/';
    }
    return path.startsWith('/') ? path : `/${path}`;
}
function escapeXml(str) {
    return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
}
/**
 * Check if a route path contains dynamic parameters (e.g., :id, :userId).
 * Routes with params need special handling - they can't be statically included
 * unless we have a way to enumerate all possible values.
 */
function hasPathParams(routePath) {
    return routePath.includes(':');
}
/**
 * Filter function to get only sitemap-eligible routes.
 * A route is eligible if:
 * - authRequired is false (public route)
 * - prerender.enabled is true (can be server-rendered)
 * - Does not contain path parameters (static path)
 * - Is not the sitemap itself
 */
function getSitemapEligibleRoutes(routes) {
    return routes.filter((route) => {
        var _a;
        // Only include public routes
        if (route.authRequired) {
            return false;
        }
        // Only include routes with prerender enabled
        if (!((_a = route.prerender) === null || _a === void 0 ? void 0 : _a.enabled)) {
            return false;
        }
        // Exclude routes with dynamic parameters
        // Future: could support a `sitemapPaths` config to enumerate dynamic values
        if (hasPathParams(route.path)) {
            return false;
        }
        // Exclude the sitemap itself
        if (route.path === '/sitemap.xml') {
            return false;
        }
        return true;
    });
}
function buildSitemapXml(routes, baseUrl) {
    const today = new Date().toISOString().split('T')[0];
    const eligibleRoutes = getSitemapEligibleRoutes(routes);
    const urlEntries = eligibleRoutes
        .map((route) => {
        const loc = `${baseUrl}${normalizeRoutePath(route.path)}`;
        // Determine priority based on path depth
        const depth = route.path.split('/').filter(Boolean).length;
        const priority = Math.max(0.5, 1.0 - depth * 0.1).toFixed(1);
        // Determine change frequency based on route type
        const changefreq = route.path === '/' ? 'weekly' : 'monthly';
        return `  <url>
    <loc>${escapeXml(loc)}</loc>
    <lastmod>${today}</lastmod>
    <changefreq>${changefreq}</changefreq>
    <priority>${priority}</priority>
  </url>`;
    })
        .join('\n');
    return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urlEntries}
</urlset>`;
}
/**
 * React component that renders the sitemap XML.
 * With rawOutput mode enabled, React's renderToString will output just the text content.
 * The html-renderer will strip the HTML wrapper and serve raw XML with the correct content type.
 */
const SitemapPage = () => {
    const routeProvider = (0, user_routes_provider_1.default)();
    const routes = (0, react_1.useMemo)(() => {
        routeProvider.getRoutes();
        return routeProvider.getFlatRoutes();
    }, [routeProvider]);
    const [xml, setXml] = (0, react_1.useState)(() => buildSitemapXml(routes, SITEMAP_CANONICAL_BASE_URL));
    (0, react_1.useEffect)(() => {
        const sitemapXml = buildSitemapXml(routes, SITEMAP_CANONICAL_BASE_URL);
        setXml(sitemapXml);
    }, [routes]);
    // Return raw XML text - with rawOutput mode, this will be served directly
    // without any HTML document wrapper
    return react_1.default.createElement(react_1.default.Fragment, null, xml);
};
let SitemapContribution = class SitemapContribution {
    constructor(routesProvider) {
        this.routesProvider = routesProvider;
        // such empty
    }
    getRoute() {
        return {
            path: '/sitemap.xml',
            component: SitemapPage,
            icon: react_1.default.createElement(lucide_react_1.FileText, null),
            navBar: false,
            name: 'Sitemap',
            exact: true,
            root: false,
            forceParent: '/',
            authRequired: false,
            prerender: {
                enabled: true,
                rawOutput: true,
                contentType: 'application/xml',
                rawRenderer: async (context) => {
                    this.routesProvider.getRoutes();
                    const routes = this.routesProvider.getFlatRoutes();
                    return generateSitemapXml(routes);
                }
            },
        };
    }
};
exports.SitemapContribution = SitemapContribution;
exports.SitemapContribution = SitemapContribution = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(routes_1.RoutesProvider)),
    __metadata("design:paramtypes", [Object])
], SitemapContribution);
/**
 * Export a function to generate sitemap XML directly (useful for server-side generation).
 * This can be used by build scripts or server middleware to generate the sitemap.
 */
function generateSitemapXml(routes) {
    return buildSitemapXml(routes, SITEMAP_CANONICAL_BASE_URL);
}
